import { Area, Unit } from '@silbo/core';
import { TFunction } from 'i18next';

export const describeBedLocation = (t: TFunction<'environmental-cleaning'>, bed: Area, unit?: Unit): string => {
  const room = bed.parent?.name;
  return [room && t('mission.room', { name: room }), unit?.name].filter(Boolean).join(' · ');
};
